import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const ordersApi = createApi({
  reducerPath: 'orders',

  baseQuery: createBaseQueryWithReauth('/orders'),

  tagTypes: ['Orders'],

  endpoints: builder => ({
    getOrders: builder.query({
      query: ({ page = 1, keyword = '', user_id = '', merchant_id = '',  dateFrom = "", dateTo="",status=""   } = {}) => {

        const params = {
          page, // додаємо параметр page до запиту
          keyword,
          user_id,
          merchant_id,
           dateFrom,
          dateTo,
          status
        };
        return {
          url: `/all`,
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Orders'],
    }),


    getOrdersA: builder.query({
      query: ({ page = 1, keyword = '', dateFrom = "", dateTo=""} = {}) => {

        const params = {
          page, // додаємо параметр page до запиту
          keyword,
          dateFrom,
          dateTo
        };


        
        return {
          url: `/done?keyword=${keyword}`,
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Orders'],
    }),
 getOrder: builder.query({
      query: (id) => ({
        url: `/view?id=${id}`,
        method: 'GET',
      }),
      providesTags: ['Orders'],
    }),
    confirmOrder: builder.mutation({
      query: (id) => ({
        url: `/confirm?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Orders'],
    }),
    cancelOrder: builder.mutation({
      query: (id) => ({
        url: `/fiscalize?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Orders'],
    }),

    returnOrders: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/return?id=${id}&comment=${comment}`,
        method: 'POST',
      }),
      invalidatesTags: ['Orders'],
    }),
    viewOrder: builder.mutation({
      query: ({ id }) => ({
        url: `/view?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Orders'],
    }),

    confirmOrder: builder.mutation({
      query: ({ id }) => ({
        url: `/confirm?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Orders'],
    }),

    cancelOrder: builder.mutation({
      query: ({ id }) => ({
        url: `/cancel?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Orders'],
    }),
  }),
});

export const {
    useGetOrdersAQuery,
  useGetOrdersQuery,
    useGetOrderQuery,
  useCancelOrderMutation,
useConfirmOrderMutation,
  useReturnOrdersMutation,
  useViewOrderMutation,

} = ordersApi;
